// import React, { useEffect, useState } from 'react';
// import { DownOutlined } from '@ant-design/icons';
// import { Badge, Card, Col, Dropdown, notification, Row, Space, Table } from 'antd';
// import axios from 'axios';
// import { baseUrl } from '../../config';
// import moment from 'moment';

// const items = [
//     {
//         key: '1',
//         label: 'Action 1',
//     },
//     {
//         key: '2',
//         label: 'Action 2',
//     },
// ];
// const TrackingList = () => {
//     const [trackingList, setTrackingList] = useState([]);
//     const [pagination, setPagination] = useState({});
//     const [currentPage, setCurrentPage] = useState(1);
//     const [limit, setLimit] = useState(10);
//     const [sortField, setSortField] = useState(null);
//     const [sortOrder, setSortOrder] = useState(null);
//     const [search, setSearch] = useState('');
//     const [filters, setFilters] = useState({
//         name: '',
//         description: '',
//         status: ''
//     });
//     const [expandedRowKeys, setExpandedRowKeys] = useState([]);
//     const [expandedData, setExpandedData] = useState({});

//     useEffect(() => {
//         getTrackingList();
//     }, []);

//     async function getTrackingList(page = 1, limit = 10, sortField = null, sortOrder = null, search = '', filters = {}) {
//         try {
//             setCurrentPage(page);
//             setLimit(limit);
//             const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
//             const searchParam = search ? `&search=${search}` : '';
//             const filterParams = Object.keys(filters)
//                 .map(key => `${key}=${filters[key]}`)
//                 .join('&');
//             const response = await axios.get(`${baseUrl}/tracking/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
//                 headers: {
//                     Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//                 }
//             });
//             if (response.data.status) {
//                 setTrackingList(response.data.result);
//                 setPagination({
//                     current: page,
//                     pageSize: limit,
//                     total: response.data.totalCount
//                 });
//             } else {
//                 notification.info({
//                     message: 'Info',
//                     description: response.data.message,
//                     placement: 'topRight'
//                 });
//             }
//         } catch (error) {
//             console.error("API error:", error);
//             notification.info({
//                 message: 'Info',
//                 description: error.response?.data?.message,
//                 placement: 'topRight'
//             });
//         }
//     };

//     const handleExpand = (expanded, record) => {
//         if (expanded) {
//             setExpandedRowKeys([...expandedRowKeys, record.key]);
//         } else {
//             setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
//         }
//     };


//     const expandedRowRender = (record) => {
//         const columns = [
//             // {
//             //     title: 'Date',
//             //     dataIndex: 'date',
//             //     key: 'date',
//             // },
//             {
//                 title: 'Column',
//                 dataIndex: 'column',
//                 key: 'column',
//             },
//             {
//                 title: 'Old Value',
//                 dataIndex: 'oldValue',
//                 key: 'oldValue',
//             },
//             {
//                 title: 'New Value',
//                 dataIndex: 'newValue',
//                 key: 'newValue',
//             },
//             // {
//             //     title: 'Action',
//             //     key: 'operation',
//             //     render: () => (
//             //         <Space size="middle">
//             //             <a>Pause</a>
//             //             <a>Stop</a>
//             //             <Dropdown
//             //                 menu={{
//             //                     items,
//             //                 }}
//             //             >
//             //                 <a>
//             //                     More <DownOutlined />
//             //                 </a>
//             //             </Dropdown>
//             //         </Space>
//             //     ),
//             // },
//         ];
//         console.log(record);
//         // Parse changed_data if it's a JSON string, otherwise, use it directly
//         let data = [];
//         try {
//             data = typeof record.changed_data === 'string' ? JSON.parse(record.changed_data) : record.changed_data;
//         } catch (error) {
//             console.error('Error parsing changed_data:', error);
//             data = [];
//         }

//         return <Table columns={columns} dataSource={data} pagination={false} />;
//     };




//     const columns = [
//         {
//             title: 'Module Name',
//             dataIndex: 'module_name',
//             key: 'module_name',
//         },
//         {
//             title: 'Operation Type',
//             dataIndex: 'operation_type',
//             key: 'operation_type',
//         },
//         {
//             title: 'Action By',
//             dataIndex: 'action_by',
//             key: 'action_by',
//         },
//         // {
//         //     title: 'Record',
//         //     dataIndex: 'record_id',
//         //     key: 'record_id',
//         // },
//         {
//             title: 'Date',
//             dataIndex: 'timestamp',
//             key: 'timestamp',
//         },
//         // {
//         //     title: 'Action',
//         //     key: 'operation',
//         //     render: () => <a>Publish</a>,
//         // },
//     ];

//     const handleTableChange = (pagination, filters, sorter) => {
//         const { current, pageSize } = pagination;
//         const { field, order } = sorter;
//         const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
//         setSortField(field);
//         setSortOrder(formattedOrder);
//         setFilters(filters);
//         getTrackingList(current, pageSize, field, formattedOrder, search, filters);
//     };

//     return (
//         <div className="tabled">
//             <Row gutter={[24, 0]}>
//                 <Col xs="24" xl={24}>
//                     <Card
//                         bordered={false}
//                         className="criclebox tablespace mb-24"
//                         title="Tracking"
//                         extra=""
//                     >
//                         <div className="table-responsive">
//                             <Table
//                                 columns={columns}
//                                 expandable={{
//                                     expandedRowRender,
//                                     expandedRowKeys: expandedRowKeys,
//                                     onExpand: handleExpand,
//                                 }}
//                                 dataSource={trackingList.map((user, index) => ({
//                                     key: index.toString(),
//                                     module_name: user.module_name,
//                                     operation_type: user.operation_type,
//                                     action_by: user.firstName + ' ' + user.lastName,
//                                     // record_id: user.record_id,
//                                     timestamp: user.timestamp ? moment(user.timestamp).format('DD-MM-YYYY hh:mm:ss A') : '-',
//                                     changed_data: JSON.parse(user.changed_data)
//                                 }))}
//                                 pagination={{
//                                     ...pagination,
//                                     showTotal: total => `Total ${total} records`,
//                                     style: { marginRight: 20 }
//                                 }}
//                                 onChange={handleTableChange}
//                             />
//                         </div>
//                     </Card>
//                 </Col>
//             </Row>
//         </div>
//     );
// };
// export default TrackingList;




import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, notification, Row, Table, Select, DatePicker, Input, Button, Tag, Space, Statistic } from 'antd';
import { SearchOutlined, UserOutlined, CalendarOutlined, EyeOutlined, ReloadOutlined } from '@ant-design/icons';
// Note: Replace with your HTTP client
// import axios from 'axios';
import { baseUrl } from '../../config';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Search } = Input;

const TrackingList = () => {
    const [trackingList, setTrackingList] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sortField, setSortField] = useState('timestamp');
    const [sortOrder, setSortOrder] = useState('desc');
    const [search, setSearch] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [dateRange, setDateRange] = useState([]);
    const [userList, setUserList] = useState([]);
    const [stats, setStats] = useState({
        todayTotal: 0,
        weekTotal: 0,
        activeUsers: 0
    });
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getTrackingList();
        getUserList();
        getStats();
    }, []);

    // Get list of users for filter dropdown
    async function getUserList() {
        try {
            // Replace with your HTTP client
            const response = await fetch(`${baseUrl}/staff/listAll`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            
            if (data.status) {
                setUserList(data.result);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    // Get basic statistics
    async function getStats() {
        try {
            const today = moment().format('YYYY-MM-DD');
            const response = await fetch(`${baseUrl}/tracking/stats?date=${today}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            
            if (data.status) {
                setStats(data.result);
            }
        } catch (error) {
            console.error("Error fetching stats:", error);
        }
    }

    // Get tracking list with filters
    async function getTrackingList(page = 1, limit = 10, sortField = 'timestamp', sortOrder = 'desc', search = '', selectedUser = '', dateRange = []) {
        setLoading(true);
        try {
            setCurrentPage(page);
            setLimit(limit);
            
            let params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                sortField,
                sortOrder,
                search
            });

            if (selectedUser) {
                params.append('user_id', selectedUser);
            }

            if (dateRange && dateRange.length === 2) {
                params.append('date_from', dateRange[0].format('YYYY-MM-DD'));
                params.append('date_to', dateRange[1].format('YYYY-MM-DD'));
            }

            const response = await fetch(`${baseUrl}/tracking/list?${params}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();

            if (data.status) {
                setTrackingList(data.result);
                setPagination({
                    current: page,
                    pageSize: limit,
                    total: data.totalCount
                });
            } else {
                notification.info({
                    message: 'Info',
                    description: data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.error({
                message: 'Error',
                description: 'Failed to fetch tracking data',
                placement: 'topRight'
            });
        } finally {
            setLoading(false);
        }
    }

    const handleExpand = (expanded, record) => {
        if (expanded) {
            setExpandedRowKeys([...expandedRowKeys, record.key]);
        } else {
            setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
        }
    };

    const expandedRowRender = (record) => {
        const columns = [
            {
                title: 'Field',
                dataIndex: 'column',
                key: 'column',
            },
            {
                title: 'Old Value',
                dataIndex: 'oldValue',
                key: 'oldValue',
            },
            {
                title: 'New Value',
                dataIndex: 'newValue',
                key: 'newValue',
            },
        ];

        let data = [];
        try {
            data = typeof record.changed_data === 'string' ? JSON.parse(record.changed_data) : record.changed_data;
        } catch (error) {
            console.error('Error parsing changed_data:', error);
            data = [];
        }

        return <Table columns={columns} dataSource={data} pagination={false} size="small" />;
    };

    const getActivityColor = (operation) => {
        const colors = {
            'create': 'green',
            'update': 'blue', 
            'delete': 'red',
            'view': 'cyan',
            'read': 'geekblue',
            'login': 'purple',
            'logout': 'orange'
        };
        return colors[operation?.toLowerCase()] || 'default';
    };

    const columns = [
        {
            title: 'Date & Time',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 180,
            sorter: true,
            render: (timestamp) => (
                <div>
                    <div style={{ fontWeight: 'bold' }}>
                        {moment(timestamp).format('DD-MM-YYYY')}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        {moment(timestamp).format('hh:mm:ss A')}
                    </div>
                </div>
            )
        },
        {
            title: 'Staff Member',
            dataIndex: 'action_by',
            key: 'action_by',
            width: 160,
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 'bold', color: '#1890ff' }}>
                        {record.firstName} {record.lastName}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        {record.roleName || 'Staff'}
                    </div>
                </div>
            )
        },
        {
            title: 'Activity',
            dataIndex: 'operation_type',
            key: 'operation_type',
            width: 120,
            render: (operation) => (
                <Tag color={getActivityColor(operation)} style={{ fontWeight: 'bold' }}>
                    {operation?.toUpperCase()}
                </Tag>
            )
        },
        {
            title: 'Module',
            dataIndex: 'module_name',
            key: 'module_name',
            width: 100,
            render: (module) => (
                <Tag style={{ backgroundColor: '#f0f0f0', color: '#333', border: '1px solid #d9d9d9' }}>
                    {module?.toUpperCase()}
                </Tag>
            )
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
            render: (text, record) => {
                if (text) return text;
                
                // Generate description from available data
                const action = record.operation_type?.toLowerCase();
                const module = record.module_name?.toLowerCase();
                
                switch (action) {
                    case 'create':
                        return `Created new ${module} record`;
                    case 'update':
                        return `Updated ${module} record`;
                    case 'delete':
                        return `Deleted ${module} record`;
                    case 'view':
                        return `Viewed ${module} list`;
                    case 'read':
                        return `Accessed ${module} details`;
                    default:
                        return `Performed ${action} on ${module}`;
                }
            }
        },
        {
            title: 'IP Address',
            dataIndex: 'ip_address',
            key: 'ip_address',
            width: 120,
            render: (ip) => (
                <span style={{ fontSize: '11px', color: '#666' }}>
                    {ip || 'N/A'}
                </span>
            )
        }
    ];

    const handleTableChange = (pagination, filters, sorter) => {
        const { current, pageSize } = pagination;
        const { field, order } = sorter || {};
        const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
        
        setSortField(field || 'timestamp');
        setSortOrder(formattedOrder);
        
        getTrackingList(current, pageSize, field || 'timestamp', formattedOrder, search, selectedUser, dateRange);
    };

    const handleSearch = () => {
        getTrackingList(1, limit, sortField, sortOrder, search, selectedUser, dateRange);
    };

    const handleReset = () => {
        setSearch('');
        setSelectedUser('');
        setDateRange([]);
        getTrackingList(1, limit, 'timestamp', 'desc', '', '', []);
    };

    const refreshData = () => {
        getTrackingList(currentPage, limit, sortField, sortOrder, search, selectedUser, dateRange);
        getStats();
        notification.success({
            message: 'Success',
            description: 'Data refreshed successfully!',
            placement: 'topRight'
        });
    };

    return (
        <div className="tabled">
            <Row gutter={[24, 0]}>
                {/* Statistics Cards */}
                <Col xs={24}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                        <Col xs={24} sm={12} md={6}>
                            <Card>
                                <Statistic
                                    title="Today's Activities"
                                    value={stats.todayTotal}
                                    prefix={<EyeOutlined />}
                                    valueStyle={{ color: '#3f8600', fontSize: '24px' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card>
                                <Statistic
                                    title="Active Staff Today"
                                    value={stats.activeUsers}
                                    prefix={<UserOutlined />}
                                    valueStyle={{ color: '#1890ff', fontSize: '24px' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card>
                                <Statistic
                                    title="This Week"
                                    value={stats.weekTotal}
                                    prefix={<CalendarOutlined />}
                                    valueStyle={{ color: '#722ed1', fontSize: '24px' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card>
                                <Statistic
                                    title="Total Records"
                                    value={pagination.total || 0}
                                    valueStyle={{ color: '#cf1322', fontSize: '24px' }}
                                />
                            </Card>
                        </Col>
                    </Row>
                </Col>

                {/* Main Tracking Table */}
                <Col xs={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                    📊 Staff Activity Tracking
                                </span>
                                <Badge 
                                    count={trackingList.length} 
                                    style={{ backgroundColor: '#52c41a' }} 
                                />
                            </div>
                        }
                        extra={
                            <Space>
                                <Button 
                                    icon={<ReloadOutlined />} 
                                    onClick={refreshData}
                                    type="default"
                                >
                                    Refresh
                                </Button>
                                <Button onClick={handleReset} size="small">
                                    Reset Filters
                                </Button>
                            </Space>
                        }
                    >
                        {/* Enhanced Filters Section */}
                        <div style={{ 
                            background: '#fafafa', 
                            padding: '16px', 
                            borderRadius: '6px', 
                            marginBottom: '16px',
                            border: '1px solid #f0f0f0'
                        }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ marginBottom: '8px', fontWeight: '500' }}>Search:</div>
                                    <Search
                                        placeholder="Search by staff name or activity"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onSearch={handleSearch}
                                        enterButton
                                        size="large"
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ marginBottom: '8px', fontWeight: '500' }}>Staff Member:</div>
                                    <Select
                                        placeholder="Select Staff Member"
                                        style={{ width: '100%' }}
                                        value={selectedUser}
                                        onChange={setSelectedUser}
                                        allowClear
                                        showSearch
                                        size="large"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {userList.map(user => (
                                            <Option key={user.id} value={user.id}>
                                                {user.firstName} {user.lastName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ marginBottom: '8px', fontWeight: '500' }}>Date Range:</div>
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        value={dateRange}
                                        onChange={setDateRange}
                                        format="DD-MM-YYYY"
                                        size="large"
                                        placeholder={['Start Date', 'End Date']}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ marginBottom: '8px', fontWeight: '500' }}>Action:</div>
                                    <Button 
                                        type="primary" 
                                        icon={<SearchOutlined />}
                                        onClick={handleSearch}
                                        size="large"
                                        style={{ width: '100%' }}
                                    >
                                        Apply Filters
                                    </Button>
                                </Col>
                            </Row>
                        </div>

                        {/* Activity Table */}
                        <div className="table-responsive">
                            <Table
                                columns={columns}
                                loading={loading}
                                expandable={{
                                    expandedRowRender,
                                    expandedRowKeys: expandedRowKeys,
                                    onExpand: handleExpand,
                                    rowExpandable: (record) => {
                                        try {
                                            const data = typeof record.changed_data === 'string' ? 
                                                JSON.parse(record.changed_data) : record.changed_data;
                                            return data && Array.isArray(data) && data.length > 0;
                                        } catch {
                                            return false;
                                        }
                                    },
                                }}
                                dataSource={trackingList.map((item, index) => ({
                                    key: index.toString(),
                                    module_name: item.module_name,
                                    operation_type: item.operation_type,
                                    action_by: item.action_by,
                                    firstName: item.firstName,
                                    lastName: item.lastName,
                                    roleName: item.roleName,
                                    timestamp: item.timestamp,
                                    description: item.description,
                                    ip_address: item.ip_address,
                                    changed_data: item.changed_data
                                }))}
                                pagination={{
                                    ...pagination,
                                    showTotal: (total, range) => 
                                        `Showing ${range[0]}-${range[1]} of ${total} activities`,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '50', '100'],
                                    style: { marginTop: 16 },
                                    showQuickJumper: true
                                }}
                                onChange={handleTableChange}
                                size="middle"
                                scroll={{ x: 1000 }}
                                rowClassName={(record, index) => 
                                    index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                                }
                            />
                        </div>

                        {/* Quick Activity Summary */}
                        {trackingList.length > 0 && (
                            <div style={{ 
                                marginTop: '20px', 
                                padding: '16px', 
                                background: '#f6ffed', 
                                border: '1px solid #b7eb8f',
                                borderRadius: '6px'
                            }}>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={8}>
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#52c41a' }}>
                                                {trackingList.filter(item => item.operation_type === 'create').length}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666' }}>Creates</div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1890ff' }}>
                                                {trackingList.filter(item => item.operation_type === 'update').length}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666' }}>Updates</div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#722ed1' }}>
                                                {trackingList.filter(item => item.operation_type === 'view').length}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666' }}>Views</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Empty State */}
                        {!loading && trackingList.length === 0 && (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                color: '#999'
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
                                <div style={{ fontSize: '16px', marginBottom: '8px' }}>No activities found</div>
                                <div style={{ fontSize: '14px' }}>
                                    Try adjusting your filters or check back later
                                </div>
                            </div>
                        )}
                    </Card>
                </Col>
            </Row>

            {/* Custom CSS for better table appearance */}
            <style jsx>{`
                .table-row-light {
                    background-color: #fafafa;
                }
                .table-row-dark {
                    background-color: #ffffff;
                }
                .ant-table-tbody > tr:hover > td {
                    background-color: #e6f7ff !important;
                }
                .ant-statistic-content {
                    font-size: 20px;
                }
                .ant-card-head-title {
                    font-size: 16px;
                }
            `}</style>
        </div>
    );
};

export default TrackingList;
